const hasRealId = (d) => d.id != null && typeof d.id !== 'string';
const elementKey = (d) => `${d.flowElementId}:${d.dataGroupId ?? ''}`;
export function reconcileSavedDatas(staleDatas, apiDatas, allSavedIds) {
    const sentIds = (allSavedIds || []).filter((id) => id != null);
    const apiElementKeys = new Set(apiDatas.map(elementKey));
    const wasJustSaved = (d) => (d.id != null && sentIds.includes(d.id)) ||
        (!hasRealId(d) && apiElementKeys.has(elementKey(d)));
    const preservedLocal = staleDatas.filter((d) => hasRealId(d) && sentIds.includes(d.id) && !!d.needSave);
    const preservedIds = new Set(preservedLocal.map((d) => d.id));
    return [
        ...staleDatas.filter((d) => !wasJustSaved(d) && !preservedIds.has(d.id)),
        ...preservedLocal,
        ...apiDatas.filter((d) => !preservedIds.has(d.id)),
    ];
}
